var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { createStore } from 'redux';
import reducer from './reducers';
import { initState } from './reducers/token';
import { initState as themeInitState } from './reducers/theme';
import { initState as styleInitState } from './reducers/style';
export * from './reducers/interface';
export default (function (state) {
  if (state === void 0) {
    state = {
      theme: {},
      token: {},
      style: {}
    };
  }
  return createStore(reducer, {
    theme: __assign(__assign({}, themeInitState), state.theme),
    token: __assign(__assign({}, initState), state.token),
    style: __assign({}, styleInitState)
  }, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
});
export var getConfigVars = function getConfigVars(key) {
  return function (state) {
    var _a = state.token.variables,
      component = _a.component,
      style = _a.style;
    var config = style[key] || component[key];
    if (config) {
      return __assign(__assign({}, config), {
        list: (config.list || []).map(function (item) {
          var value = item.value;
          if (item.key in state.token.editTokens) {
            value = state.token.editTokens[item.key].value;
          } else if (item.key in state.token.savedTokens) {
            value = state.token.savedTokens[item.key].value;
          }
          return __assign(__assign({}, item), {
            value: value
          });
        })
      });
    }
    return config || {};
  };
};